<script>
import Modal from '@/components/atoms/Modal'
import InputLine from '@/components/atoms/inputlib/components/InputLine'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import isEmpty from 'lodash.isempty'
import Badge from '@/components/molecules/Badge'
export default {
    name: 'ModalCoupon',
    components: { Badge, ButtonLoader, InputLine, Modal },
    data() {
        return {
            loading: false,
            removeLoading: false,
            couponCode: null,
            invalidCouponCode: undefined,
            error: undefined,
            max: 200,
        }
    },
    computed: {
        regexp() {
            return new RegExp(this.$couponREGEX)
        },
        cart() {
            return this.$cart
        },
        emptyCoupon() {
            return isEmpty(this.couponCode)
        },
        hasCoupon() {
            return !isEmpty(this.cart.calculation.coupon_code)
        },
        hasValidCoupon() {
            return this.hasCoupon && !this.cart.calculation.coupon_invalid
        },
        tooLong() {
            return this.couponCode?.length > this.max
                ? this.$t('labels.error.invalid_length_long', { max: this.max })
                : undefined
        },
        allowCoupons() {
            return (
                !this.cart.calculation.promotion || this.cart.calculation.promotion?.allow_coupons
            )
        },
    },
    methods: {
        openCoupon() {
            if (!this.cart.loading) this.$refs.ModalCoupon.openModal()
        },
        closeCoupon(closeModal) {
            if (this.error) this.cart.coupon_code = null
            this.error = undefined
            this.couponCode = null
            this.invalidCouponCode = false
            if (this.hasCoupon && !this.hasValidCoupon) {
                this.cart.coupon_code = null
                this.cart.calculate()
            }
            if (closeModal) this.$refs.ModalCoupon.closeModal()
        },
        applyCoupon() {
            this.loading = true
            this.cart.coupon_code = this.couponCode
            this.cart
                .calculate()
                .then(() => {
                    if (this.cart.calculation.coupon_invalid) {
                        this.error = this.cart.calculation.coupon_invalid
                    } else {
                        this.$refs.ModalCoupon.closeModal()
                        this.$nextTick(() => {
                            this.couponCode = null
                        })
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        resetCoupon() {
            this.removeLoading = true
            this.cart.coupon_code = null
            this.cart.calculate().finally(() => {
                this.removeLoading = false
            })
        },
        validateCoupon(val) {
            if (this.error) this.error = undefined
            this.invalidCouponCode = this.regexp.test(val)
                ? undefined
                : this.$t('cart.coupon_invalid')
        },
    },
}
</script>

<template lang="pug">
.modal-coupon(v-if="allowCoupons")
    badge.mr-3(v-if="hasValidCoupon && !removeLoading" type="secondary" icon="fa-solid fa-tag" @close="resetCoupon" :disabled="cart.loading" icon-type="primary") {{ cart.calculation.coupon_code }}
    button.btn.btn-primary.btn-xs.d-flex(@click="openCoupon" v-else)
        icon(icon="fa-solid fa-tag")
        span {{$t('cart.add_coupon')}}
    modal(ref="ModalCoupon" @close="closeCoupon")
        template(v-slot:header)
            .modal-header-text {{$t('cart.coupon_code')}}
        template(v-slot:body)
            input-line.mb-0(
                v-model="couponCode"
                @input='validateCoupon'
                :max="max"
                :error="invalidCouponCode || tooLong || error") {{$t('cart.coupon_text')}}
        template(v-slot:footer)
            button.btn.btn-secondary(@click="closeCoupon(true)") {{ $t('base.cancel') }}
            button-loader.btn.btn-primary(@click="applyCoupon" :disabled="invalidCouponCode || tooLong || emptyCoupon" :loading="loading" inline) {{ $t('base.submit') }}
</template>
